// @flow

import { useState, useEffect } from 'react';

const STORAGE_KEY = 'champsToPlay';

export function useChampsToPlayStorage() {
  const [champsToPlay, setChampsToPlay] = useState({});
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      try {
        setChampsToPlay(JSON.parse(stored));
      } catch (e) {
        console.error('Failed to parse champsToPlay from localStorage', e);
      }
    }
    setIsLoaded(true);
  }, []);

  const updateStorage = (newChampsToPlay) => {
    setChampsToPlay(newChampsToPlay);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newChampsToPlay));
  };

  const toggleToPlay = (championName) => {
    const current = champsToPlay[championName] || { toPlay: false, comment: '', order: 0 };
    updateStorage({
      ...champsToPlay,
      [championName]: {
        ...current,
        toPlay: !current.toPlay,
      },
    });
  };

  const setComment = (championName, comment) => {
    const current = champsToPlay[championName] || { toPlay: false, comment: '', order: 0 };
    updateStorage({
      ...champsToPlay,
      [championName]: {
        ...current,
        comment,
      },
    });
  };

  const reorderList = (reorderedList) => {
    const updated = { ...champsToPlay };
    reorderedList.forEach((champ, index) => {
      updated[champ.name] = {
        ...updated[champ.name],
        order: index,
      };
    });
    updateStorage(updated);
  };

  return {
    champsToPlay,
    isLoaded,
    toggleToPlay,
    setComment,
    reorderList,
  };
}
